import React from "react";
import { Avatar as AvatarContainer } from "@mui/material";
import theme from "../../theme";

interface Props {
  src?: string;
  initials: string;
  heightWidth?: string | number;
}

const Avatar: React.FC<Props> = (props) => {
  const { src, initials, heightWidth } = props;
  return (
    <AvatarContainer
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        width: heightWidth,
        height: heightWidth,
        border: `2px solid ${theme.palette.text.primary}`,
        cursor: "pointer",
      }}
      src={src}
    >
      {initials}
    </AvatarContainer>
  );
};
export default Avatar;
